import camelcaseKeys from 'camelcase-keys'

import { siteMetadata } from 'config'
import { fetchJSON } from './fetch'

const { apiHost } = siteMetadata

export const fetchModels = async () => {
  const url = `${apiHost}/api/v1/internal/models`
  return camelcaseKeys(await fetchJSON(url), { deep: true })
}

export const fetchModel = async (modelId) => {
  const url = `${apiHost}/api/v1/internal/models/${modelId}`
  return camelcaseKeys(await fetchJSON(url), { deep: true })
}

/**
 * Get subtree for either risk or intervention by ID
 * @param {*} modelId - model ID
 * @param {*} subtreeId - 'risk' or intervention ID
 * @returns
 */
export const fetchModelSubtree = async (modelId, subtreeId) => {
  const url = `${apiHost}/api/v1/internal/models/${modelId}/${subtreeId}`
  return camelcaseKeys(await fetchJSON(url), { deep: true })
}
